export const capitalizeFirstLetter = (word: string) =>
  // eslint-disable-next-line no-unsafe-optional-chaining
  word?.charAt(0)?.toUpperCase() + word?.slice(1)
